import table from './data/county-population.json';

/**
 * Estonia's county populations, bundled rather than fetched: the API counts police reports and has
 * no idea how many people live anywhere. The figures are Statistics Estonia's own, and the vintage
 * travels with them because a rate per 1000 people is only readable if you know which 1000.
 */

export const COUNTY_POPULATION: Readonly<Record<string, number>> = table.population;

/** As the source writes it, for the popover beside the per-capita toggle. */
export const POPULATION_VINTAGE = `${table.source}, seisuga ${table.vintage}`;
export const POPULATION_URL = table.url;

/** A county's population, or `null` for anything the table has no figure for — the `UNSPECIFIED`
 * sentinel included, which is not a place and therefore has no denominator. */
export function countyPopulation(county: string): number | null {
  return COUNTY_POPULATION[county] ?? null;
}
